var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 17v-4.89q0-2.133.84-4.398a19.4 19.4 0 0 1 2.216-4.266Q4.434 1.41 6.08 0l4.501 2.56a26 26 0 0 0-2.082 4.233q-.873 2.265-.874 5.317V17zm11.42 0v-4.89q0-2.133.84-4.398a19.4 19.4 0 0 1 2.216-4.266Q15.853 1.41 17.5 0L22 2.56a26 26 0 0 0-2.082 4.233q-.874 2.265-.874 5.317V17z"
})));
export default SvgQuote;